import { createSliceContext } from "./CreateSliceContext";

interface LoginModalSliceProps {
  show: boolean;
  onHide?: () => void;
  welcomeSubHeading?: string;
  location: Location;
  isEditReservation?: boolean;
  isFrom?: string;
}

const defaultLoginModalSliceValues: LoginModalSliceProps = {
  show: false,
  onHide: undefined,
  welcomeSubHeading: "",
  location: { pathname: "/" } as Location,
  isEditReservation: false,
  isFrom: "",
};

export const {
  Provider: LoginModalSliceProvider,
  useContext: useLoginModalSliceContext,
} = createSliceContext<LoginModalSliceProps>(
  "LoginModal",
  defaultLoginModalSliceValues
);
